$(document).ready(function () {
    let helper = require('./helper');
    let ToastrController = new (require('./services/ToastrController'));

    $('.js-service-visibility').on('click', function(){
        let $this = $(this);
        let data = {
            id: $this.data('id'),
            value: $this.prop('checked')
        };

        $.ajax({
            url: helper.getOrigin() + '/api/services/visibility',
            method: 'POST',
            data: data,
            dataType: 'json',

            success: function (data) {
                if (data.status == 'error') {
                    ToastrController.showDanger(data.message);
                } else {
                    ToastrController.showSuccess(data.message);
                }
            }
        });
    });
});
